import { useContext, useState } from 'react';
import { Button } from 'reactstrap';
import { useFormContext } from 'react-hook-form';
import PayeeSelect from './PayeeSelect';
import NewPayee from './NewPayee';
import { renderIcon } from '~/shared/components/icons';
import { FundRequestContext } from '~/context/fundrequests';
import { CampaignContext } from '~/context/campaign';

export const PayableTo = ({ initialLoadComplete = true }: { initialLoadComplete?: boolean }) => {
    const { watch } = useFormContext();
    const [{ fundRequest, selectedPayee }] = useContext(FundRequestContext);
    const [{ campaign }] = useContext(CampaignContext);
    const directVendorPayOnly = campaign?.campaignDetail?.direct_vendor_pay_only;
    const [showOtherPayee, setShowOtherPayee] = useState(false);
    const [payeesFound, setPayeesFound] = useState(false);
    const [toggleSwapPayee, setToggleSwapPayee] = useState(true);
    
    // Watch form values
    const paymentType = watch('payment_type');
    const selectedVendorId = watch('vendor');

    const handleAddNewPayee = () => {
        setShowOtherPayee(true);
    };

    const handleCancelPayee = () => {
        setShowOtherPayee(false);
    };

    return (
        <>
            {directVendorPayOnly && (
                <div
                    className='rounded p-3 fw-bold'
                    style={{ backgroundColor: '#fff9e6', marginBottom: 16 }}
                >
                    Reimbursements to this campaign are not allowed. Direct
                    payments to payees only.
                </div>
            )}

            <PayeeSelect
                showOtherPayee={showOtherPayee}
                setToggleSwapPayee={setToggleSwapPayee}
                toggleSwapPayee={toggleSwapPayee}
                setPayeesFound={setPayeesFound}
                payeesFound={payeesFound}
                initialLoadComplete={initialLoadComplete}
            />

            {toggleSwapPayee && showOtherPayee && (
                <NewPayee
                    payeesFound={payeesFound}
                    onCancel={handleCancelPayee}
                    onSave={() => setShowOtherPayee(false)}
                />
            )}

            {payeesFound && toggleSwapPayee && !showOtherPayee && (
                <div>
                    <Button
                        color='link'
                        size='sm'
                        outline={false}
                        onClick={handleAddNewPayee}
                        style={{
                            marginLeft: 2,
                            padding: 'auto',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        {renderIcon('add')}
                        ADD NEW PAYEE
                    </Button>
                </div>
            )}

            {/* Display message if payee is selected, not verified, and payment type is ACH */}
            {selectedVendorId && selectedPayee && !selectedPayee.verified_in_mip && paymentType === 'ACH' && (
                <div style={{
                    backgroundColor: '#fff3cd',
                    border: '2px solid #6db4d6',
                    borderRadius: '8px',
                    padding: '16px',
                    margin: '16px 0',
                    color: '#495057',
                    fontWeight: 'bold'
                }}>
                    This Payee still needs to be verified by Help Hope Live. Once verified, Help Hope Live will follow up if ACH information is needed.
                </div>
            )}
        </>
    );
};
